import { Button } from '@hg/stylizator/components'
import { themeColors } from '@hg/stylizator/utils'
import * as React from 'react'
import styled from 'styled-components'

interface IProps {
  text: string
  url: string
}

const SignupButton: React.FC<React.PropsWithChildren<IProps>> = (props) => (
  <SignUpButtonWrapper>
    <Button
      type="primary"
      size="regular"
      onClick={() => {
        window.open(props.url, '_blank')
      }}
      className="signup-button"
    >
      {props.text}
    </Button>
  </SignUpButtonWrapper>
)

const SignUpButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .signup-button {
    width: 50%;
    background-color: ${themeColors.pink['60']};

    &:hover {
      background-color: ${themeColors.pink['50']};
    }

    &:active {
      background-color: ${themeColors.pink['70']};
    }

    &:focus {
      box-shadow: 0 0 0 4px ${themeColors.pink['30']};
    }
  }
`

export default SignupButton
